import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: 'root'
})
export class SanitizeService {

  constructor(
    public sanitizer: DomSanitizer
  ){}

public sanitizeInput(inputValue) {
    return this.decodeEntities(this.sanitizer.sanitize(
      SecurityContext.HTML,
      inputValue
    ));
}

private decodeEntities(s){    
  var str, temp= document.createElement('p');    
  temp.innerHTML= s;    
  str= temp.textContent || temp.innerText;    
  temp=null;
  return str;}
}
